"use client";

import React, { useEffect, useState } from "react";
import { Layout } from "antd";
import { ArrowLeftOutlined, PoweroffOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import "../../styles/HeaderBar.css";

import { appRouter } from "../../constants/routerConstant";
import {
  getCurrentInternalStep,
  getCurrentStep,
  getUserToken,
  saveCurrentStep,
  saveCurrentInternalStep,
  getDMQStepFlow,
} from "../../utils/formStorage";

const { Header } = Layout;

const HeaderBar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [showBack, setShowBack] = useState(false);
  const [showLogout, setShowLogout] = useState(false);

  //  mainStep is now STRING
  const [mainStep, setMainStep] = useState(getCurrentStep() || "");
  const [internalStep, setInternalStep] = useState(Number(getCurrentInternalStep()) || 1);

  //  Pages where logout icon should NOT be visible
  const notShowLogout = [appRouter.DMQLogin, appRouter.SubmissionComplete, appRouter.AppDisclaimer];

  /* ---------------- Sync step state ---------------- */
  useEffect(() => {
    const syncSteps = () => {
      setMainStep(getCurrentStep() || "");
      setInternalStep(Number(getCurrentInternalStep()) || 1);
    };

    window.addEventListener("storage", syncSteps);
    return () => window.removeEventListener("storage", syncSteps);
  }, []);

  /* ---------------- Logout visibility ---------------- */
  useEffect(() => {
    const shouldHideLogout = notShowLogout.some((route) => pathname.startsWith(route));
    setShowLogout(!shouldHideLogout);
  }, [pathname]);

  /* ---------------- Back button visibility ---------------- */
  useEffect(() => {
    const stepFlow = getDMQStepFlow();

    if (!Array.isArray(stepFlow) || stepFlow.length === 0) {
      setShowBack(false);
      return;
    }

    const currentIndex = stepFlow.findIndex((step) => step.id === mainStep);

    const isFirstStep = currentIndex === 0 && internalStep === 1;

    const onFormFilling = pathname.startsWith(appRouter.FormFilling);

    setShowBack(onFormFilling && !isFirstStep);
  }, [mainStep, internalStep, pathname]);

  /* UPDATED BACK LOGIC (STRING STEP SUPPORT) */
  const handleBack = () => {
    const stepFlow = getDMQStepFlow();

    if (!Array.isArray(stepFlow) || stepFlow.length === 0) return;

    const currentStep = getCurrentStep();
    const currentIndex = stepFlow.findIndex((step) => step.id === currentStep);

    if (currentIndex === -1) return;

    const currentInternal = Number(getCurrentInternalStep()) || 1;

    let newMainStep = currentStep;
    let newInternalStep = currentInternal;

    const currentStepConfig = stepFlow[currentIndex];

    /*
STEP 1 — HANDLE INTERNAL STEP BACK
*/
    if (currentStepConfig?.internalSteps > 0 && currentInternal > 1) {
      newInternalStep = currentInternal - 1;
    } else {
      /*
  STEP 2 — MOVE TO PREVIOUS MAIN STEP
  */
      const previousStep = stepFlow[currentIndex - 1];

      if (!previousStep) return;

      newMainStep = previousStep.id;

      newInternalStep = previousStep.internalSteps > 0 ? previousStep.internalSteps : 1;
    }

    saveCurrentStep(newMainStep);
    saveCurrentInternalStep(newInternalStep);

    setMainStep(newMainStep);
    setInternalStep(newInternalStep);

    window.dispatchEvent(
      new CustomEvent("dmq-step-change", {
        detail: {
          step: newMainStep,
          internalStep: newInternalStep,
        },
      })
    );
  };

  /* ---------------- Logout Logic ---------------- */
  const handleLogout = () => {
    const memberToken = getUserToken();
    navigate(`${appRouter.DMQLogin}?data=${encodeURIComponent(memberToken)}`);
  };

  return (
    <Header className="custom-header">
      {/* Back Button */}
      {showBack && (
        <div className="header-icon left-icon" onClick={handleBack}>
          {" "}
          <ArrowLeftOutlined />{" "}
        </div>
      )}

      {/* Center Logo */}
      <div className="header-logo">
        <img src="/hlLogoFit.png" alt="HDFC Life Logo" height={36} />
      </div>

      {/* Logout Button */}
      {showLogout && (
        <div className="header-icon right-icon" onClick={handleLogout}>
          <PoweroffOutlined />
        </div>
      )}
    </Header>
  );
};

export default HeaderBar;
